import React, { useEffect } from 'react';
import feather from 'feather-icons';
import { useAuth } from '../context/AuthContext';

function Header() {
  const { user, logout } = useAuth();

  useEffect(() => {
    feather.replace();
  });

  const roleBadge = user?.role === 'partner'
    ? { label: 'Partner', bg: '#0d6efd' }
    : { label: 'Admin', bg: '#198754' };

  return (
    <nav className="navbar navbar-expand navbar-light bg-white border-bottom px-4" style={{ height: '3.5rem' }}>
      <div className="container-fluid">
        <span className="navbar-brand fw-bold" style={{ fontSize: '0.875rem', color: '#31374a' }}>
          NekotoWan {roleBadge.label}
        </span>
        <div className="d-flex align-items-center gap-3">
          {user && (
            <span style={{ fontSize: '0.8125rem', color: '#525b75' }}>
              {user.displayName || user.email}
              <span
                className="badge ms-2"
                style={{ backgroundColor: roleBadge.bg, fontSize: '0.6875rem', verticalAlign: 'middle' }}
              >
                {roleBadge.label}
              </span>
            </span>
          )}
          <button
            className="btn btn-phoenix-secondary btn-sm d-flex align-items-center gap-1"
            onClick={logout}
          >
            <i data-feather="log-out" style={{ width: 14, height: 14 }}></i>
            Logout
          </button>
        </div>
      </div>
    </nav>
  );
}

export default Header;
